import React from 'react';
import { handleClick } from '../../../helpers';
import css from './SubMenuOffice.module.scss';
import classnames from 'classnames';

const SubMenuOffice = ({ submenu, active, toggleMenu }) => {
    return (
        <div className={css.officeSubMenuMob}>
            {!!submenu.submenu.length &&
                submenu.submenu.map((subMenuItem, i) => (
                    <div
                        key={`subMenuItem_${i}`}
                        className={css.officeSubMenuItemMob}
                        onClick={(e) => {
                            handleClick(e, subMenuItem, () => {}, toggleMenu);
                        }}
                    >
                        <p
                            style={{ cursor: 'pointer' }}
                            className={classnames(
                                active.subactive.includes(subMenuItem.name)
                                    ? [css.officeMenuItemText, css.officeMenuItemTextHover]
                                    : css.officeMenuItemText
                            )}
                        >
                            {subMenuItem.title}
                        </p>
                    </div>
                ))}
        </div>
    );
};
export default SubMenuOffice;
